<template>
  <div class="about">
    <div class="section-background">
      <div class="container">
        <div class="hero">
          <div class="text">
            <p class="sub-title">
              Our latest articles
            </p>
            <h1 class="title">
              Blog
            </h1>
            <br>
            <div class="row">
              <div class="col-sm-12 col-md-4">
                <a
                  href="article/why-ab-is-the-master-of-reverse-sweep"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/news/reverse-sweep.jpg"
                    alt="Why AB is the master of reverse sweep"
                  >
                  <div class="blog-body">
                    <h3>Why AB is the master of reverse sweep</h3>
                    <div class="date-author">
                      Madan Raj Rajagopal | Jul 30, 2020
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-sm-12 col-md-4">
                <a
                  href="article/playing-with-a-purpose"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/news/purpose.jpg"
                    alt="Playing with a purpose"
                  >
                  <div class="blog-body">
                    <h3>Playing with a purpose</h3>
                    <div class="date-author">
                      Karl Marais | June 29, 2020
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-sm-12 col-md-4">
                <a
                  href="article/not-just-a-bowler"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/news/bowler.jpg"
                    alt="Not just a bowler"
                  >
                  <div class="blog-body">
                    <h3>Not just a bowler</h3>
                    <div class="date-author">
                      Karl Marais | June 12, 2020
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-sm-12 col-md-4">
                <a
                  href="article/cricket-vs-corona"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/news/corona.jpg"
                    alt="Cricket vs Corona"
                  >
                  <div class="blog-body">
                    <h3>Cricket vs Corona</h3>
                    <div class="date-author">
                      Madan Raj Rajagopal | May 15, 2020
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-sm-12 col-md-4">
                <a
                  href="article/ludimos-smart-lane"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/news/smart-lane.jpg"
                    alt="Ludimos smart lane"
                  >
                  <div class="blog-body">
                    <h3>Ludimos smart lane</h3>
                    <div class="date-author">Karl Marais | May 11, 2020</div>
                  </div>
                </a>
              </div>
              <div class="col-sm-12 col-md-4">
                <a
                  href="article/overcome-the-obstacle"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/news/obstacle.jpg"
                    alt="Overcome this obstacle"
                  >
                  <div class="blog-body">
                    <h3>Overcome this obstacle</h3>
                    <div class="date-author">Karl Marais | March 30, 2020</div>
                  </div>
                </a>
              </div>
              <div class="col-sm-12 col-md-4">
                <a
                  href="article/beyond-the-nets"
                  class="blog-container"
                >
                  <img
                    class="img-fluid"
                    src="../assets/img/news/net.jpg"
                    alt="Beyond the nets"
                  >
                  <div class="blog-body">
                    <h3>Beyond the nets</h3>
                    <div class="date-author">Karl Marais | March 20, 2020</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="visual">
            <div class="background">
              <img
                src="../assets/img/hero-background.svg"
                alt="background visual"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Articles",
  metaInfo() {
    return {
      title: this.textEllipsis(`Latest Articles`, 25),
    };
  },
};
</script>

<style lang="scss" scoped>
.blog-container {
  h3 {
    line-height: 30px;
    font-size: 18px;
  }
  img {
    max-width: 999px;
    max-height: 999px;
    margin: 0;
    border-radius: 0;
  }
}
</style>
